export default __webpack_public_path__ + "static/media/hlb.78c99d36.svg";